import { IAppNotificationPayload } from '../../app.interfaces'

/**
 * Titles that name no particular area. Dispatch sites outside the page services still use
 * these, so the operation in the message names the card instead.
 */
const GENERIC_TITLES = ['error', 'errors', 'failed', 'failure', '']

/** Operation labels inferred from the message when the caller gave no specific title. */
const OPERATION_TITLES: { keyword: RegExp; title: string }[] = [
    { keyword: /delet|remov/i, title: 'Delete failed' },
    { keyword: /sav|updat|creat|add/i, title: 'Save failed' },
    { keyword: /upload/i, title: 'Upload failed' },
    { keyword: /export|download/i, title: 'Export failed' },
    { keyword: /get|load|fetch/i, title: 'Load failed' },
]

const FALLBACK_TITLE = 'Request failed'

/** Heading for one card in a clubbed notification dialog. */
export const resolveItemTitle = (notification: IAppNotificationPayload) => {
    const title = notification.title?.trim() || ''
    if (!GENERIC_TITLES.includes(title.toLowerCase())) return title
    const operation = OPERATION_TITLES.find(({ keyword }) => keyword.test(notification.msg || ''))
    return operation?.title || FALLBACK_TITLE
}
